/* eslint-disable quotes */
export const dateAndHoursFormat = 'dd/MM/yyyy HH:mm';
export const dateAndHoursFormatRequest = "yyyy-MM-dd'T'HH:mm:ss";
export const dateFormat = 'dd/MM/yyyy';
export const dateFormatRequest = 'yyyy-MM-dd';
